import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { inputId: String };

  pick({ params: { ahriReferenceNumber } }) {
    const input = document.getElementById(this.inputIdValue);
    if (!input) return;

    input.value = ahriReferenceNumber;
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
    input.focus();
  }
}
